import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { Input, Button } from "@mui/material";
import AgoraUIKit from "agora-react-uikit";
import { getAgoraToken, getGifts } from "../../service/api";
import db from "../../firebase.config";

const CreatorLive = () => {
  const [videoCall, setVideoCall] = useState(true);
  const [token, setToken] = useState(null);
  const [room, setRoom] = useState("");

  const navigate = useNavigate();

  const { email, room_id } = useParams();

  useEffect(async () => {
    const token = await getAgoraToken(email);
    setToken(token.token);
    setRoom(room_id);
  }, []);

  const rtcProps = {
    appId: "a6c12e924ed84f5ea68ee2994a502c9d",
    channel: email,
    token: token,
    role: "audience",
  };

  const styleProps = {
    localBtnContainer: { backgroundColor: "blueviolet" },
  };

  const callbacks = {
    EndCall: () => setVideoCall(false),
  };

  return (
    <div className="flex">
      <div
        style={{
          width: "58%",
          height: "100vh",
          display: "flex",
          flex: 1,
          backgroundColor: "#007bff22",
        }}
      >
        {videoCall && token ? (
          <>
            <AgoraUIKit
              rtcProps={rtcProps}
              callbacks={callbacks}
              styleProps={styleProps}
            />
          </>
        ) : (
          <>
            <h3
              style={{
                backgroundColor: "#007bff",
                cursor: "pointer",
                height: "2rem",
                borderRadius: 5,
                padding: 5,
                color: "#ffffff",
                fontSize: 20,
                margin: "2px",
              }}
              onClick={() => navigate("/user")}
            >
              Go Back
            </h3>
          </>
        )}
      </div>
      <div style={{ width: "38%", height: "95vh" }}>
        <Chat room={room} />
      </div>
    </div>
  );
};

export default CreatorLive;

function Chat({ room }) {
  const [messages, setMessages] = useState([]);
  const [gifts, setGifts] = useState([]);

  useEffect(async () => {
    const giftlist = await getGifts();
    setGifts(giftlist);
  }, []);

  const scroll = useRef();

  const getMessages = () => {
    onSnapshot(
      query(collection(db, "chats", room, "messages"), orderBy("timestamp")),
      (snap) => {
        setMessages(snap.docs.map((doc) => doc.data()));
      }
    );
  };

  const sendGift = async (image) => {
    try {

      toast.custom(<strong>Charging...</strong>);
      const user_data = JSON.parse(sessionStorage.getItem("userdata"));
      let d = {
        email: user_data.email,
        amount: 20,
      };
      
      const URL = `https://creater-app.herokuapp.com`;
      let response = await axios.put(`${URL}/user/charge`, d);
      console.log()
      if (response.status === 200) {
        console.log("send", response);
        const data = JSON.parse(sessionStorage.getItem("userdata"));

        const colRef = collection(db, "chats");
        const docRef = doc(colRef, room);
        const colRef2 = collection(docRef, "messages");
        await setDoc(doc(colRef2), {
          image: image,
          timestamp: serverTimestamp(),
          name: data.name,
          photoURL: data.image || "",
          type: "image",
        });

        getMessages();
      } else {
        toast.error("Not enough balance");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <div className="flex flex-col justify-end h-full">
      <div className="msgs">
        {messages.length > 0 ? (
          messages.map((msg, index) => (
            <div key={index}>
              <div className="flex items-start gap-2 p-1.5">
                <img
                  src={`${msg.photoURL}`}
                  alt="user"
                  className="rounded-full w-8 h-8"
                />
                <div className="flex flex-col justify-start">
                  <p className="font-semibold">{msg.name}</p>
                  {msg.type === "text" ? (
                    <p className="text-xs">{msg.message}</p>
                  ) : (
                    <img
                      src={`${msg.image}`}
                      className="w-40 h-32 object-cover object-center rounded-md"
                    />
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
      <div className="z-20">
        {gifts.length > 0 && (
          <div className="h-20 overflow-x-auto overscroll-x-contain w-11/12 flex items-center flex-nowrap gap-2 p-2">
            {gifts.map((gift, index) => (
              <div
                key={index}
                className="h-full"
                onClickCapture={() => sendGift(gift.image)}
              >
                <img
                  src={`${gift.image}`}
                  alt="gift"
                  className="rounded-md object-cover object-center w-20 h-full"
                />
              </div>
            ))}
          </div>
        )}
        <SendMessage scroll={scroll} room={room} getMessages={getMessages} />
      </div>
    </div>
  );
}

function SendMessage({ scroll, room, getMessages }) {
  const [msg, setMsg] = useState("");

  async function sendMessage(e) {
    e.preventDefault();
    const data = JSON.parse(sessionStorage.getItem("userdata"));

    const colRef = collection(db, "chats");
    const docRef = doc(colRef, room);
    const colRef2 = collection(docRef, "messages");
    await setDoc(doc(colRef2), {
      message: msg,
      timestamp: serverTimestamp(),
      name: data.name,
      photoURL: data.image || "",
      type: "text",
    });
    setMsg("");

    getMessages();
  }

  return (
    <div className="bg-white w-full">
      <div ref={scroll}></div>
      <form onSubmit={sendMessage}>
        <div className="sendMsg">
          <Input
            style={{
              width: "90%",
              fontSize: "15px",
              fontWeight: "550",
              marginLeft: "5px",
              marginBottom: "-3px",
            }}
            placeholder="Message..."
            type="text"
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
          />
          <Button
            style={{
              width: "18%",
              fontSize: "15px",
              fontWeight: "550",
              margin: "4px 5% -13px 5%",
              maxWidth: "200px",
            }}
            type="submit"
          >
            Send
          </Button>
        </div>
      </form>
    </div>
  );
}
